module.exports = __webpack_public_path__ + "static/img/emotions1_14.2e80939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_14.png
// module id = h8wr
// module chunks = 0